'use client';

/**
 * Boundary de segmento de ruta: conserva el layout (navbar/footer) y sirve para
 * la mayoría de los crashes. `global-error.tsx` es el reemplazo total de la
 * página y queda solo para cuando falla el layout raíz.
 */
import { useEffect } from 'react';
import { captureException } from '@/lib/observability';
import { useTranslation } from '@/i18n/hooks/useTranslation';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { t } = useTranslation();
  useEffect(() => {
    captureException(error, { source: 'nextjs-route-error', digest: error.digest });
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <h2 className="text-lg font-semibold">{t('site.error.title')}</h2>
      <p className="max-w-sm text-sm opacity-70">
        {t('site.error.description')}
      </p>
      <button
        onClick={reset}
        className="mt-2 rounded-xl border px-5 py-2 text-sm font-medium opacity-80 transition hover:opacity-100"
      >
        {t('site.error.retry')}
      </button>
    </div>
  );
}
